<template>
    <footer
        :class="[
            'tw-border-t',
            theme === 'dark' ? 'tw-bg-[#0f1114] tw-border-[#1e2024] tw-text-gray-400' : 'tw-bg-[#e9eef6] tw-border-gray-200 tw-text-gray-600'
        ]"
    >
        <div class="tw-px-2 md:tw-px-4 lg:tw-px-6 tw-py-2 md:tw-py-3">
            <div class="tw-flex tw-flex-col tw-gap-2 md:tw-gap-4 md:tw-flex-row md:tw-items-center md:tw-justify-between">
                <div class="tw-text-[11px] md:tw-text-xs lg:tw-text-sm tw-font-medium tw-tracking-wide tw-truncate">
                    {{ vue_app_name }} &copy; 2026
                </div>
                <div
                    :class="[
                        'tw-text-[9px] md:tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.15em] md:tw-tracking-[0.2em] tw-px-2 md:tw-px-3 tw-py-1 tw-rounded-full tw-border tw-w-fit',
                        theme === 'dark' ? 'tw-border-[#1e2024] tw-text-gray-500' : 'tw-border-gray-300 tw-text-gray-500'
                    ]"
                >
                    Developed by Winckieel
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    setup () {
        const vue_app_name = process.env.VUE_APP_NAME;
        return {
            vue_app_name
        }
    },
    computed: {
        ...mapGetters('ui', ['theme'])
    }
}
</script>
